<div class="tin-cell">
  <span>{{ showTin ? tinValue : getMaskedTin() }}</span>
  <button class="toggle-btn" (click)="toggleShowTin($event)" [attr.aria-label]="showTin ? 'Hide TIN' : 'Show TIN'">
    <mat-icon>{{ showTin ? 'visibility_off' : 'visibility' }}</mat-icon>
  </button>
</div>
